<template lang="pug">
    .center-x-y.take-max-height
        section.has-text-centered
            h1.title(v-if="code") {{ code }}
            h3.message(v-if="message") {{ message }}
</template>

<script>

export default {
    name: 'Error',
    props: {
        code: {
            type: Number,
            required: false,
            default: 404,
        },
        message: {
            type: String,
            required: false,
            default: 'Not found',
        },
    }
}
</script>

<style lang="sass" scoped>

.center-x-y.take-max-height
    min-height: 100%
    display: flex
    align-items: center
    justify-content: center

    section.has-text-centered
        /* color: #aaacb5 */
        text-align: center

        .title
            color: rgba(0,0,0,0.3)
            font-size: 4rem
            font-weight: 100
            margin-bottom: 10px

        .message
            font-size: 1rem
            font-weight: 400
            margin-top: 10px
            // margin-bottom: 80px
</style>

